class ScrollToConfirmation {
	constructor() {
		console.log("ScrollToConfirmation constructor running");

		window.setTimeout(() => {
			const confirmation = document.querySelector(
				".gform_confirmation_message"
			);

			if (!confirmation) {
				console.log("No confirmation message found");
				return;
			}

			confirmation.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}, 300);
	}
}

export default ScrollToConfirmation;
